module.exports = __webpack_public_path__ + "static/media/illustration-bidding-done.0434a574.svg";